"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenterBackRoleBonuses = exports.CenterBackExpandedRoles = void 0;
const playerBonuses_1 = require("../playerBonuses"); // Added import
const playerTraits_1 = require("../playerTraits");
const rarity_1 = require("../rarity");
const zones_1 = require("../zones");
const baseRoles_1 = require("./baseRoles");
var CenterBackExpandedRoles;
(function (CenterBackExpandedRoles) {
    // --- Uncommon --- GENERIC (Consistent with other positions)
    CenterBackExpandedRoles["RAPID_CENTER_BACK"] = "RAPID_CENTER_BACK";
    CenterBackExpandedRoles["POWERFUL_CENTER_BACK"] = "POWERFUL_CENTER_BACK";
    CenterBackExpandedRoles["TIRELESS_CENTER_BACK"] = "TIRELESS_CENTER_BACK";
    CenterBackExpandedRoles["DETERMINED_CENTER_BACK"] = "DETERMINED_CENTER_BACK";
    CenterBackExpandedRoles["HEROIC_CENTER_BACK"] = "HEROIC_CENTER_BACK";
    CenterBackExpandedRoles["RELIABLE_CENTER_BACK"] = "RELIABLE_CENTER_BACK";
    CenterBackExpandedRoles["LUCKY_CENTER_BACK"] = "LUCKY_CENTER_BACK";
    CenterBackExpandedRoles["TENACIOUS_CENTER_BACK"] = "TENACIOUS_CENTER_BACK";
    CenterBackExpandedRoles["INSPIRATIONAL_CENTER_BACK"] = "INSPIRATIONAL_CENTER_BACK";
    CenterBackExpandedRoles["DOMINANT_CENTER_BACK"] = "DOMINANT_CENTER_BACK";
    CenterBackExpandedRoles["IMPACT_CENTER_BACK"] = "IMPACT_CENTER_BACK";
    CenterBackExpandedRoles["STUBBORN_CENTER_BACK"] = "STUBBORN_CENTER_BACK";
    CenterBackExpandedRoles["VOCAL_CENTER_BACK"] = "VOCAL_CENTER_BACK";
    CenterBackExpandedRoles["RETENTIVE_CENTER_BACK"] = "RETENTIVE_CENTER_BACK";
    CenterBackExpandedRoles["NO_NONSENSE_CENTER_BACK"] = "NO_NONSENSE_CENTER_BACK";
    CenterBackExpandedRoles["MAN_MARKING"] = "MAN_MARKING";
    CenterBackExpandedRoles["FIREY_CENTER_BACK"] = "FIREY_CENTER_BACK";
    CenterBackExpandedRoles["VERSATILE_CENTER_BACK"] = "VERSATILE_CENTER_BACK";
    // --- Uncommon --- CB SPECIFIC / FUNCTIONAL
    CenterBackExpandedRoles["SWEEPER"] = "SWEEPER";
    CenterBackExpandedRoles["COVERING_CENTER_BACK"] = "COVERING_CENTER_BACK";
    CenterBackExpandedRoles["EXPERT_CENTER_BACK"] = "EXPERT_CENTER_BACK";
    CenterBackExpandedRoles["ORCHESTRATING_CENTER_BACK"] = "ORCHESTRATING_CENTER_BACK";
    CenterBackExpandedRoles["EXPERIENCED_CENTER_BACK"] = "EXPERIENCED_CENTER_BACK";
    // --- Rare --- GENERIC COMBINATIONS (Two basic traits)
    CenterBackExpandedRoles["ATHLETIC_CENTER_BACK"] = "ATHLETIC_CENTER_BACK";
    CenterBackExpandedRoles["ROBUST_CENTER_BACK"] = "ROBUST_CENTER_BACK";
    CenterBackExpandedRoles["AGGRESSIVE_CENTER_BACK"] = "AGGRESSIVE_CENTER_BACK";
    CenterBackExpandedRoles["ENERGETIC_CENTER_BACK"] = "ENERGETIC_CENTER_BACK";
    CenterBackExpandedRoles["VALIANT_CENTER_BACK"] = "VALIANT_CENTER_BACK";
    CenterBackExpandedRoles["PLUCKY_CENTER_BACK"] = "PLUCKY_CENTER_BACK";
    CenterBackExpandedRoles["COMMANDING_CENTERBACK"] = "COMMANDING_CENTERBACK";
    CenterBackExpandedRoles["ROUSING_DEFENDER"] = "ROUSING_DEFENDER";
    // --- Rare --- ARCHETYPAL CENTER BACKS
    CenterBackExpandedRoles["BALL_PLAYING_DEFENDER"] = "BALL_PLAYING_DEFENDER";
    CenterBackExpandedRoles["TECHNICAL_DEFENDER"] = "TECHNICAL_DEFENDER";
    CenterBackExpandedRoles["LIBERO"] = "LIBERO";
    CenterBackExpandedRoles["ROCK"] = "ROCK";
    CenterBackExpandedRoles["RESOLUTE_CENTER_BACK"] = "RESOLUTE_CENTER_BACK";
    CenterBackExpandedRoles["IMPOSING_CENTER_BACK"] = "IMPOSING_DEFENDER";
    CenterBackExpandedRoles["TRADITIONAL_CENTER_BACK"] = "TRADITIONAL_CENTER_BACK";
    CenterBackExpandedRoles["LOCKDOWN_DEFENDER"] = "LOCKDOWN_DEFENDER";
    CenterBackExpandedRoles["MODERN_CENTER_BACK"] = "MODERN_CENTER_BACK";
    CenterBackExpandedRoles["WARRIOR"] = "WARRIOR";
    CenterBackExpandedRoles["COMPOSED_DEFENDER"] = "COMPOSED_DEFENDER"; //retaining & defensive expert
})(CenterBackExpandedRoles || (exports.CenterBackExpandedRoles = CenterBackExpandedRoles = {}));
exports.CenterBackRoleBonuses = {
    CENTER_BACK: {
        rarity: rarity_1.Rarity.COMMON,
        // Using MAIN/SECOND/THIRD bonuses for the base role
        statBlock: { block: playerBonuses_1.PlayerBonuses.MAIN_POSITION_ATTRIBUTE, intercept: playerBonuses_1.PlayerBonuses.SECOND_POSITION_ATTRIBUTE, tackle: playerBonuses_1.PlayerBonuses.THIRD_POSITION_ATTRIBUTE },
        positionsEnabled: [zones_1.Zones.DEFENSE], playerTraits: [],
    },
    // --- Uncommon Roles ---
    RAPID_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.RAPID],
    },
    POWERFUL_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.POWERFUL],
    },
    TENACIOUS_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.UNDERDOG],
    },
    HEROIC_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.HERO],
    },
    DETERMINED_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DETERMINED],
    },
    DOMINANT_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DOMINANT],
    },
    LUCKY_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LUCKY],
    },
    SWEEPER: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.SWEEPER],
    },
    RETENTIVE_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SECURE_POSSESSION],
    },
    TIRELESS_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.STAMINA],
    },
    RELIABLE_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.RELIABLE],
    },
    INSPIRATIONAL_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.INSPIRE],
    },
    STUBBORN_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.UNYIELDING],
    },
    COVERING_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.COVER],
    },
    EXPERT_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.DEFENSIVE_EXPERT],
    },
    VOCAL_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.ORGANISED],
    },
    MAN_MARKING: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.MAN_MARKING],
    },
    IMPACT_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.SUPER_SUB],
    },
    ORCHESTRATING_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SHORT_PASS],
    },
    PLUCKY_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LUCKY],
    },
    TECHNICAL_DEFENDER: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.FIRST_TOUCH],
    },
    NO_NONSENSE_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LONG_BALL],
    },
    EXPERIENCED_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK], rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [playerTraits_1.PlayerTraits.WISE],
    },
    FIREY_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.IGNITE],
    },
    VERSATILE_CENTER_BACK: {
        parentRoles: [baseRoles_1.BaseRoles.CENTER_BACK],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.VERSATILE],
    },
    // --- Rare Roles ---
    ENERGETIC_CENTER_BACK: {
        parentRoles: [CenterBackExpandedRoles.RAPID_CENTER_BACK, CenterBackExpandedRoles.TIRELESS_CENTER_BACK],
        rarity: rarity_1.Rarity.RARE, statBlock: { intercept: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [], // Inherits RAPID, STAMINA
    },
    // --- Rare Roles ---
    ATHLETIC_CENTER_BACK: {
        parentRoles: [CenterBackExpandedRoles.RAPID_CENTER_BACK, CenterBackExpandedRoles.POWERFUL_CENTER_BACK],
        rarity: rarity_1.Rarity.RARE, statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [], // Inherits RAPID, POWERFUL
    },
    AGGRESSIVE_CENTER_BACK: {
        parentRoles: [CenterBackExpandedRoles.RAPID_CENTER_BACK, CenterBackExpandedRoles.TENACIOUS_CENTER_BACK],
        rarity: rarity_1.Rarity.RARE, statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [], // Inherits RAPID, UNDERDOG
    },
    ROBUST_CENTER_BACK: {
        parentRoles: [CenterBackExpandedRoles.POWERFUL_CENTER_BACK, CenterBackExpandedRoles.TENACIOUS_CENTER_BACK],
        rarity: rarity_1.Rarity.RARE, statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [], // Inherits POWERFUL, UNDERDOG
    },
    BALL_PLAYING_DEFENDER: {
        parentRoles: [CenterBackExpandedRoles.RETENTIVE_CENTER_BACK, CenterBackExpandedRoles.ORCHESTRATING_CENTER_BACK],
        rarity: rarity_1.Rarity.RARE, statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [], // Inherits PRESS_RESISTANT, SECURE_POSSESSION
    },
    IMPOSING_DEFENDER: {
        parentRoles: [CenterBackExpandedRoles.DOMINANT_CENTER_BACK, CenterBackExpandedRoles.POWERFUL_CENTER_BACK],
        rarity: rarity_1.Rarity.RARE, statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [], // Inherits DOMINANT, POWERFUL
    },
    RESOLUTE_CENTER_BACK: {
        parentRoles: [CenterBackExpandedRoles.DETERMINED_CENTER_BACK, CenterBackExpandedRoles.STUBBORN_CENTER_BACK],
        rarity: rarity_1.Rarity.RARE, statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [], playerTraits: [], // Inherits DETERMINED, UNYIELDING
    },
    LIBERO: {
        parentRoles: [CenterBackExpandedRoles.RETENTIVE_CENTER_BACK, CenterBackExpandedRoles.SWEEPER],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    ROCK: {
        parentRoles: [CenterBackExpandedRoles.STUBBORN_CENTER_BACK, CenterBackExpandedRoles.POWERFUL_CENTER_BACK],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    TRADITIONAL_CENTER_BACK: {
        parentRoles: [CenterBackExpandedRoles.NO_NONSENSE_CENTER_BACK, CenterBackExpandedRoles.POWERFUL_CENTER_BACK],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    LOCKDOWN_DEFENDER: {
        parentRoles: [CenterBackExpandedRoles.MAN_MARKING, CenterBackExpandedRoles.EXPERT_CENTER_BACK],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    MODERN_CENTER_BACK: {
        parentRoles: [CenterBackExpandedRoles.RETENTIVE_CENTER_BACK, CenterBackExpandedRoles.STUBBORN_CENTER_BACK],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    WARRIOR: {
        parentRoles: [CenterBackExpandedRoles.TENACIOUS_CENTER_BACK, CenterBackExpandedRoles.STUBBORN_CENTER_BACK],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    COMMANDING_CENTERBACK: {
        parentRoles: [CenterBackExpandedRoles.EXPERIENCED_CENTER_BACK, CenterBackExpandedRoles.VOCAL_CENTER_BACK],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    ROUSING_DEFENDER: {
        parentRoles: [CenterBackExpandedRoles.INSPIRATIONAL_CENTER_BACK, CenterBackExpandedRoles.DETERMINED_CENTER_BACK],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    COMPOSED_DEFENDER: {
        parentRoles: [CenterBackExpandedRoles.RETENTIVE_CENTER_BACK, CenterBackExpandedRoles.EXPERT_CENTER_BACK],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    VALIANT_CENTER_BACK: {
        parentRoles: [CenterBackExpandedRoles.HEROIC_CENTER_BACK, CenterBackExpandedRoles.DETERMINED_CENTER_BACK],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { block: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, positionsEnabled: [],
        playerTraits: [],
    },
};
